import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageToastService} from "../../../../../service/message-toast.service";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../../../shared/model/response/ApiResponse";
import {EventService} from "../../../../../service/api/event.service";

@Component({
    selector: 'app-remove-all-events-modal',
    templateUrl: './remove-all-events-modal.component.html',
    standalone: false
})
export class RemoveAllEventsModalComponent implements OnInit {

  @Output('onCloseModal') onCloseModal = new EventEmitter<any>();

  verificationText = "Remover tudo permanentemente"

  form: FormGroup;

  isLoading = false

  constructor(
    private eventService: EventService,
    private toastService: MessageToastService
  ) {
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm(): void {
    this.form = new FormGroup({
      "verification": new FormControl(null, Validators.required),
    });

  }

  apiOnRemove() {
    this.isLoading = true

    const req = {verification: this.form.get("verification").value}

    this.eventService.deleteAccountEvents(req)
      .pipe(tap({
          next: (response) => {
            this.toastService.success(response.message)
            this.form.reset()
            this.onCloseModal.emit()
          },
          error: (err: ApiResponse<any>) => this.toastService.error(err.message)
        })
        , finalize(() => this.isLoading = false)
      )
      .subscribe();
  }
}
